import { render, staticRenderFns } from "./dashboardAccount.vue?vue&type=template&id=209bdc94&"
import script from "./dashboardAccount.vue?vue&type=script&lang=js&"
export * from "./dashboardAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports